export default __webpack_public_path__ + "images/0xc5a9848b9d145965d821aaec8fa32aaee026492d.png";